var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", staticStyle: { width: "auto" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("h1", { staticClass: "title" }, [
          _c("img", {
            staticStyle: {
              "margin-left": "2px",
              "margin-bottom": "-4px",
              "margin-right": "4px",
            },
            attrs: {
              src: `https://flagcdn.com/w80/${_vm.mails.countryCode.toLowerCase()}.png`,
            },
          }),
          _vm._v(
            " " +
              _vm._s(_vm.mails.enduserCode + " - " + _vm.mails.enduserName) +
              " "
          ),
        ]),
      ]),
      _c("div", { staticClass: "infos" }, [
        _c("div", { staticClass: "flex-column" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("pages.pickup_management.stats.interval"))),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.mailsInterval))]),
        ]),
      ]),
      _c("div", { staticStyle: { margin: "50px" } }, [
        _c(
          "button",
          {
            staticClass: "button is-warning is-outlined is-small",
            on: { click: _vm.close },
          },
          [
            _c("b-icon", { attrs: { icon: "chevron-left" } }),
            _c("span", [_vm._v(_vm._s(_vm.$t("global.back")))]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "flex-column" }, [
        _c("i", [
          _vm._v(
            " " +
              _vm._s(_vm.$t("pages.pickup_management.stats.period")) +
              " " +
              _vm._s(_vm.$dayjs(_vm.rangeDates[0]).format("DD/MM/YYYY")) +
              " - " +
              _vm._s(_vm.$dayjs(_vm.rangeDates[1]).format("DD/MM/YYYY")) +
              " "
          ),
        ]),
      ]),
      _c("div", { staticClass: "container body" }, [
        _c("div", { staticClass: "flex-column margin" }, [
          _c("span", { staticClass: "subtitle" }, [
            _vm._v(
              _vm._s(_vm.$t("pages.pickup_management.stats.response_rate"))
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "stat",
              style: { color: _vm.getResponseRateClass() },
            },
            [_vm._v(_vm._s(_vm.responseRate.value + _vm.responseRate.suffix))]
          ),
        ]),
        _c("div", { staticClass: "flex-column margin" }, [
          _c("span", { staticClass: "subtitle" }, [
            _vm._v(
              _vm._s(_vm.$t("pages.pickup_management.stats.response_time"))
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "stat",
              style: { color: _vm.getResponseTimeClass() },
            },
            [_vm._v(_vm._s(_vm.responseTime.value + _vm.responseTime.suffix))]
          ),
        ]),
        _c("div", { staticClass: "flex-column margin" }, [
          _c("span", { staticClass: "subtitle" }, [
            _vm._v(
              _vm._s(_vm.$t("pages.pickup_management.stats.declared_quantity"))
            ),
          ]),
          _c("span", { staticClass: "stat blue" }, [
            _vm._v(_vm._s(_vm.declaredQty)),
          ]),
        ]),
        _c("div", { staticClass: "flex-column margin" }, [
          _c("span", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("pages.pickup_management.stats.mail_sent"))),
          ]),
          _c("span", { staticClass: "stat blue" }, [
            _vm._v(_vm._s(_vm.mailsCount)),
          ]),
        ]),
        _c("div", { staticClass: "flex-column margin" }, [
          _c("span", { staticClass: "subtitle" }, [
            _vm._v(
              _vm._s(_vm.$t("pages.pickup_management.stats.reminder_sent"))
            ),
          ]),
          _c(
            "span",
            { staticClass: "stat", style: { color: _vm.getRemindersClass() } },
            [_vm._v(_vm._s(_vm.remindersCount))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }